<template>
  <div>
    <top-header :banners="props.banners" />
    <week-day-event />
    <date-search-button class="topPageHeader-dateButton" />
  </div>
</template>

<script setup lang="ts">
import type { TopBanner } from '@/types/TopBanner'

const props = defineProps<{
  banners: TopBanner[]
}>()

const TopHeader = defineAsyncComponent(() => import('@/components/top/TopHeader.vue'))
const DateSearchButton = defineAsyncComponent(() => import('@/components/top/DateSearchButton.vue'))
const WeekDayEvent = defineAsyncComponent(() => import('@/components/top/WeekDayEvent.vue'))
</script>

<style lang="scss" scoped>
</style>
